import React from "react";
import { FiRefreshCw } from "react-icons/fi";

// Add a proper refresh button component
const RefreshButton = ({ onClick, isLoading, text = "Refresh" }) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className="px-3 py-3 rounded-xl bg-black hover:bg-black/60 text-white transition-colors border border-white/30"
      title={text}
    >
      <div className={`${isLoading ? 'animate-spin' : ''}`}>
        <FiRefreshCw size={18} />
      </div>
    </button>
  );
};

export default RefreshButton; 